export const VOLLEYBALL_HEADER_COPY = {
  eyebrow: "Sports Hub • Volleyball",
  title: "Volleyball Dashboard",
  description: "Track live games, standings, and teams from volleyball leagues worldwide",
};
